const protocol = location.protocol;
export const APP_ENV = "staging";

export const LARAVEL_SESSION_COOKIE = "staging";
export const AUTH_LOW_SECURITY_COOKIE_NAME = `ttp_auth_ls_${APP_ENV}`;

export const TTP_AMAZON_S3 = `${protocol}//s3.tamtam.pro/prod`;
export const TTP_API_URL = `${protocol}//api.staging.tamtam.pro`;
export const TTP_HOME_URL = `${protocol}//one.staging.tamtam.pro/`;
export const TAMTAM_API_URL = `${protocol}//api.staging.tamtam.pro`;

export const TTP_BLOG_URL = `${protocol}//blog.staging.tamtam.pro/`;
export const TTP_FLUX_URL = `${protocol}//ezine.staging.tamtam.pro/`;
export const TTP_EMAILING_URL = `${protocol}//sending.staging.tamtam.pro/`;
export const TTP_EVENT_URL = `${protocol}//staging.tamtam.pro/ttp/`;
export const TTP_TALK_URL = `${protocol}//talk.staging.tamtam.pro`;
export const TTP_PAYMENT_URL = `${protocol}//stats.staging.tamtam.pro/`;
export const TTP_MEDIA_URL = `${protocol}//media.staging.tamtam.pro:3003/`;
export const TTP_FORUM_URL = `${protocol}//forum.staging.tamtam.pro:3003/`;
export const TTP_WEBTOOL_URL = `${protocol}//webtool.staging.tamtam.pro:3003/`;
export const TTP_UA_URL = `${protocol}//staging.unitedassociates.be/`;
export const S3_FOLDER_URL = `https://s3.tamtam.pro/prod`;
export const S3_GEOJSON_FOLDER_URL = `https://s3.tamtam.pro/production`;
export const S3_STATS_FOLDER_URL = `https://s3.tamtam.pro/production/apps`;

export const TTP_WEBINAR_STATS_URL = "https://webinar-1.staging.tamtam.pro";
export const TTP_API_STATS_URL = "https://api.staging.tamtam.pro";
export const S3_URL = `https://s3.tamtam.pro/staging`;

export const RIB = `007 826 0002684000000426 89`;

export const CLIENT_CREDENTIAL = {
  grant_type: "client_credentials",
  client_id: "10012",
  client_secret: "EmailingSecretS#K$",
  scope: "ttp"
};

export const TAMTAM_CLIENT_ID = { "F.F.F.": 1, "IEC-IAB": 3 };

export const PSPID = "TamtamInternationalOgone";
export const OGONE_URL = "https://secure.ogone.com/ncol/test/orderstandard.asp";

export const client_id = "tamtam";
export const client_password =
  "M5O6eLNTKgW06W4C5F2DTmZONaWphzWYBugtsHosDcAD5WtxKY";
export const server_url = "https://api.sandbox.mangopay.com";
export const version = "V2.01";

export const DROPBOX_CLIENT_ID = "5ne7nj2awvfaj1m";
export const DROPBOX_REDIRECT_URI =
  "https://api.staging.tamtam.pro/billing/coda-file/dropbox-token";



// WEBPACK FOOTER //
// ./app/config/ConfigStaging.js